import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// import {
//   getClientRoute,
//   getProjectRoute,
//   getFreelanceProjectRoute,
// } from '../../utils/breadcrumbUtil'

// export const fetchCurrentBreadCrumb = createAsyncThunk(
//   'settings/fetchCurrentBreadCrumb',
//   async (currentLocation, { getState, rejectWithValue }) => {
//     try {
//       const { auth } = getState()
//       // Take the current link & figures out if it is in clients or projects page then recursively find the rest of breadcrumbs
//       const clientRegex = new RegExp('^/clients.*$')
//       const checkClient = clientRegex.test(currentLocation)

//       const projectRegex = new RegExp('^/projects.*$')
//       const checkProject = projectRegex.test(currentLocation)

//       let id =
//         (checkClient && currentLocation.replace('/clients/', '')) ||
//         (checkProject && currentLocation.replace('/projects/', ''))
//       id = id.replace('/', '')

//       if (checkClient) {
//         const route = await getClientRoute(currentLocation, id, auth.userInfo.tenantId)
//         return [route]
//       }
//       if (checkProject && !auth.userInfo.groups.includes('freelancer')) {
//         const route = await getProjectRoute(currentLocation, id, auth.userInfo.tenantId)
//         return route.reverse()
//       } else {
//         const route = await getFreelanceProjectRoute(currentLocation, id, auth.userInfo.tenantId)
//         return route.reverse()
//       }
//     } catch (err) {
//       console.log('err: ', err)
//       return rejectWithValue(err)
//     }
//   }
// )

export const commonSlice = createSlice({
  name: 'common',
  initialState: {
    searchTerm: '',
    breadcrumbRoutes: [{ route: '/', label: 'Home' }],
    error: null,
  },
  reducers: {
    setBreadCrumbRoute: (state, action) => {
      state.breadcrumbRoutes = [action.payload]
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload
    },
  },
  // extraReducers: {
  //   [fetchCurrentBreadCrumb.pending]: (state, action) => {
  //     state.fetchCurrentBreadCrumbApiStatus = 'loading'
  //   },
  //   [fetchCurrentBreadCrumb.fulfilled]: (state, action) => {
  //     state.fetchCurrentBreadCrumbApiStatus = 'succeeded'
  //     state.breadcrumbRoutes = [{ route: '/', label: 'Home' }, ...action.payload]
  //   },
  //   [fetchCurrentBreadCrumb.rejected]: (state, action) => {
  //     state.fetchCurrentBreadCrumbApiStatus = 'failed'
  //     state.error = action.error.message
  //   },
  // },
})

export const { pushBreadCrumbRoute, clickBreadCrumb, setBreadCrumbRoute, setSearchTerm } =
  commonSlice.actions

export default commonSlice.reducer
